import React from "react";
import AdminAgendaPage from "../../Admin/agenda/AdminAgendaPage"; // ajusta si la ruta cambia
import { useAuth } from "../../../context/AuthContext";

export default function TrabajadorAgendaPage() {
  const { user } = useAuth();

  return (
    <AdminAgendaPage
      readOnly={true}
      profesionalId={user?.uid}
    />
  );
}
